import EventListener from "@/mixins/EventListener.mixin";
import { NumericPickerComponent } from "helix-vue-components";
import cloneDeep from "lodash/cloneDeep";
import { Component, Mixins, Prop } from "vue-property-decorator";
import Template from "./LocationSeatsManagerModal.template.vue";

@Component({
  mixins: [Template],
  components: {
    "numeric-picker": NumericPickerComponent
  }
})
export default class LocationSeatsManagerModal extends Mixins(EventListener) {
  @Prop({ default: 5 }) public locationSeats!: number;
  public seats: number = 0;
  @Prop({ default: 0 }) public min!: number;
  @Prop({ default: 0 }) public costPerUnit!: string;

  public get diff(): number {
    return Math.abs(this.locationSeats - this.seats);
  }

  public get action() {
    return this.locationSeats - this.seats < 0
      ? this.$t("adding")
      : this.$t("removing");
  }

  public get edited(): boolean {
    return this.locationSeats !== this.seats;
  }

  public get upgraded(): boolean {
    return this.seats > this.locationSeats;
  }

  public get downgraded(): boolean {
    return this.seats < this.locationSeats;
  }

  public get totalCost() {
    return this.diff * +this.costPerUnit;
  }

  protected mounted() {
    this.seats = cloneDeep(this.locationSeats);
    this.keyUp("Esc", () => {
      this.close();
    });
    this.keyUp("Enter", () => {
      this.save();
    });
  }

  protected close() {
    this.$emit("reject");
  }

  protected save() {
    this.$emit("resolve", {
      locations: this.seats,
      action: this.upgraded ? "UPGRADE" : "DOWNGRADE"
    });
  }
}
